import React, { Component } from 'react'
import { connect } from 'react-redux'

export const ON_BOARDING_STEPS_IN_PROGRESS = 5

export const ON_BOARDING_STEP_WELCOME = 0
export const ON_BOARDING_STEP_SPORT = 1
export const ON_BOARDING_STEP_RELATIONSHIP = 2
export const ON_BOARDING_STEP_CITY = 3
export const ON_BOARDING_STEP_BIRTHDAY = 4
export const ON_BOARDING_STEP_ACHIEVEMENT = 5

export const ON_BOARDING_STEPS = [
    ON_BOARDING_STEP_WELCOME,
    ON_BOARDING_STEP_SPORT,
    ON_BOARDING_STEP_RELATIONSHIP,
    ON_BOARDING_STEP_CITY,
    ON_BOARDING_STEP_BIRTHDAY,
    ON_BOARDING_STEP_ACHIEVEMENT,
]

/**
 * Check if component can be rendered in on boarding current step
 * USAGE - @inOnBoarding(ON_BOARDING_STEP_WELCOME) or @inOnBoarding(ON_BOARDING_STEP_BIRTHDAY)
 *
 * @param {number} showForStep
 * @returns {function(*)}
 */
export default function inOnBoarding(showForStep) {
    return function(Child) {
        class OnBoarding extends Component {
            render = () => {
                const { currentStep } = this.props

                if (currentStep !== showForStep) {
                    return null
                }

                return (
                    <Child { ...this.props } />
                )
            }
        }

        return connect(state => ({
            currentStep: state.onBoarding.currentStep,
        }))(OnBoarding)
    }
}
